import { ColumnDef } from "./types";
import { MIN_SPREADSHEET_COLUMN_WIDTH_PX } from "./useSpreadsheetColumnResize";

/**
 * The leading and trailing filler tracks `centerColumns` adds. Bounded column
 * tracks grow to their max first; these `auto` tracks then split whatever
 * width is left, so the columns sit in the middle (as ViewTable's fillers do).
 */
const CENTERING_FILLER_TRACK = "minmax(0px, auto)";

/**
 * A column's track when the grid centers its columns: `minSize` to `maxSize`,
 * each falling back to `width`, so the column stops growing and leaves the
 * rest of the width to the fillers.
 */
export function getCenteredColumnTrack(column: ColumnDef): string {
    const minWidth =
        column.minSize ?? column.width ?? MIN_SPREADSHEET_COLUMN_WIDTH_PX;
    const maxWidth = column.maxSize ?? column.width;
    const maxTrack = maxWidth === undefined ? "max-content" : `${maxWidth}px`;
    return `minmax(${minWidth}px, ${maxTrack})`;
}

/** Wraps the columns' tracks in the leading and trailing filler tracks. */
export function withCenteringFillerTracks(gridTemplateColumns: string): string {
    return `${CENTERING_FILLER_TRACK} ${gridTemplateColumns} ${CENTERING_FILLER_TRACK}`;
}
